import { render } from "./newCollection.vue?vue&type=template&id=0e6a7bc2&scoped=true"
import script from "./newCollection.vue?vue&type=script&lang=js"
export * from "./newCollection.vue?vue&type=script&lang=js"

import "./newCollection.vue?vue&type=style&index=0&id=0e6a7bc2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e6a7bc2"]])

export default __exports__